module.exports = __webpack_public_path__ + "static_pc/img/logo.cec3ca2a.png";